export enum LoginType {
  MAGICLINK_START = 'magiclink.start',
  MAGICLINK_LOGIN = 'magiclink.login',
  SSO_GOOGLE = 'sso.google',
  OTP_START = 'otp.start',
  OTP_SMS_START = 'otp.sms.start',
  OTP_LOGIN = 'otp.login',
  OTP_SMS_LOGIN = 'otp.sms.login',
  GUEST_LOGIN = 'guest.login',
  CORP_PERK_STORE_GUEST_LOGIN = 'cp.guest.login',
  CORP_PERK_STORE_OTP_START = 'cp.otp.start',
  CORP_PERK_STORE_OTP_LOGIN = 'cp.otp.login',
}

export interface GuestLoginReqInput {
  userEmail: string
  userId: string
  storeId: string
  loginType?: LoginType.GUEST_LOGIN
}

export interface CorpPerkStoreGuestLoginReqInput {
  storeId: string
  loginType?: LoginType.CORP_PERK_STORE_GUEST_LOGIN
}

export interface OtpStartReqInput {
  userEmail?: string
  userPhoneNumber?: string
  loginType?: LoginType.OTP_START | LoginType.OTP_SMS_START
  storeId?: string
}

export interface OtpLoginReqInput {
  code: string
  userEmail?: string
  userPhoneNumber?: string
  loginType?: LoginType.OTP_LOGIN | LoginType.OTP_SMS_LOGIN
  storeId?: string
}

export interface OtpLoginResBody {
  token: string
  refreshToken: string
}
export interface MagicLinkStartReqInput {
  userEmail: string
  loginType: LoginType.MAGICLINK_START
}
